import { Injectable } from "@angular/core";
import { ApiService } from "@core/services/api.service";
import { ApiServiceHolder } from "@core/utils/api-service-holder";
import { Observable } from "rxjs";
import { IConfirmNotification, INotification } from "../interfaces/notification.interface";

@Injectable({
  providedIn: 'root',
})

export class NotificationService {
  unreadNotificationsCount: number = 0;

  constructor(private _api: ApiService) { }

  getNotifications(idLanguage: number): Observable<INotification[]> {
    return this._api.request(ApiServiceHolder.notification.getNotifications(idLanguage));
  }

  getUnreadNotificationsCount(): Observable<number> {
    return this._api.request(ApiServiceHolder.notification.getUnreadNotificationsCount());
  }

  confirmNotification(confirmNotification: IConfirmNotification) {
    return this._api.request(ApiServiceHolder.notification.confirmNotification(confirmNotification));
  }
}
